import { type TransactionSummaryDTO } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { usePartners } from '@capsicum/socios-core';
import { type CSSProperties, useContext } from 'react';

import { TransactionCard } from '../../../ui';

import * as S from './styles';
import { TransactionCardsContext } from './TransactionCardsContext';

export const TransactionCardsRow = ({ index, style }: { index: number; style: CSSProperties }) => {
	const {
		dataForList: { [index]: item, length }
	} = useContext(TransactionCardsContext);
	const { getPartnerBy } = usePartners();
	const isLoadingIndicator = index === length;

	const { push } = useRouter();

	const goToTransactionDetails = (transaction: TransactionSummaryDTO) => {
		push(`/wallet/transaction-details/${transaction.transactionId}`);
	};

	if (isLoadingIndicator) {
		return (
			<S.LoadingIndicatorListItem style={style}>
				<S.LoadingIndicator />
			</S.LoadingIndicatorListItem>
		);
	}

	if (item?.type === 'header') {
		return (
			<S.HeaderListItem key={`header-${item.date}`} style={style}>
				<S.SubTitle>
					<S.TextStyled>{item.date}</S.TextStyled>
				</S.SubTitle>
				<S.SubTitle>
					<S.TextStyled>{item.dailySum}</S.TextStyled>
				</S.SubTitle>
			</S.HeaderListItem>
		);
	}
	if (item?.type === 'transaction') {
		const partner = getPartnerBy(p => p.shortName === item.transaction.currencyShortCode);

		const partnerLogoUrl = partner?.images?.partnerLogo?.url;

		return (
			<S.TransactionListItem style={style}>
				<TransactionCard
					key={`transaction-${item.transaction.transactionId}`}
					{...item.transaction}
					partnerLogoUrl={partnerLogoUrl}
					onClick={() => goToTransactionDetails(item.transaction)}
				/>
			</S.TransactionListItem>
		);
	}
	// Unrecognized item type
};
